import Icon from 'veui/components/Icon'
import { IconMarket } from 'dls-icons-vue'

Icon.register('market', IconMarket)
